import {
  INVESTMENT_FLOW_MAPPER,
  MAXIMUM_SAVABLE_AMOUNT,
  MAXIMUM_SAVETAX_AMOUNT,
} from "../../constants/mf";
import {
  BUILDWEALTH_INVESTMENT_OPTIONS,
  INVESTSURPLUS_INVESTMENT_OPTIONS,
  SAVETAX_INVESTMENT_OPTIONS,
} from "../../constants/mf/investmentType";
import { formatAmountInr } from "../../utils/common/functions";
import { getSaveTaxYear } from "../../utils/mf/functions";

const BUILDWEALTH = {
  dataAid: "highGrowthFundsInvestment",
  header: {
    dataAid: "highGrowthFunds",
    title: "High growth funds",
  },
  investmentCard: {
    dataAid: "highGrowthFunds",
    title: { text: "Investment type" },
    amountTitle: { text: "Enter amount" },
    options: BUILDWEALTH_INVESTMENT_OPTIONS,
    inputPlaceholder: "Enter amount",
  },
  estimationCard: {
    dataAid: "amount",
    title: {
      text: ({ term }) => `Value after ${term} year${term > 1 ? `s` : ""}`,
    },
  },
  footer: {
    text: "CONTINUE",
    dataAid: "primary",
  },
};

const SAVETAX = {
  dataAid: "saveTax",
  header: {
    dataAid: "saveTax",
    title: "Save tax",
  },
  infoText: {
    text: `Save up to ${formatAmountInr(
      MAXIMUM_SAVABLE_AMOUNT
    )} by investing ${formatAmountInr(MAXIMUM_SAVETAX_AMOUNT)} under 80C`,
    dataAid: "info",
  },
  investmentCard: {
    dataAid: "saveTaxSip",
    title: { text: "Investment type" },
    amountTitle: { text: "Enter amount" },
    options: SAVETAX_INVESTMENT_OPTIONS,
    inputPlaceholder: "Enter amount",
  },
  estimationCard: {
    dataAid: "amount",
    title: {
      text: () => `Tax savings by ${getSaveTaxYear()}`,
    },
  },
  footer: {
    text: "CONTINUE",
    dataAid: "primary",
  },
};

const INVESTSURPLUS = {
  dataAid: "parkMySavings",
  header: {
    dataAid: "parkYourSavings",
    title: "Park your savings",
  },
  investmentCard: {
    dataAid: "parkYourSavings",
    title: { text: "Park savings for" },
    amountTitle: { text: "Enter amount" },
    options: INVESTSURPLUS_INVESTMENT_OPTIONS,
    inputPlaceholder: "Enter amount",
  },
  estimationCard: {
    dataAid: "amount",
    title: {
      text: ({ term }) => `Value after ${term} year${term > 1 ? "s" : ""}`,
    },
  },
  footer: {
    text: "CONTINUE",
    dataAid: "primary",
  },
};

const SAVE_FOR_GOAL = {
  dataAid: "customAmountDetails",
  header: {
    dataAid: "amountDetails",
    title: "Amount details",
  },
  investmentCard: {
    dataAid: "saveForAGoal",
    amountTitle: { text: "SIP amount" },
    inputPlaceholder: "Enter amount",
  },
  estimationCard: {
    dataAid: "amount",
    title: {
      text: ({ year }) => `Savings by ${year}`,
    },
  },
  footer: {
    text: "CONTINUE",
    dataAid: "primary",
  },
};

const INVESTMENT_TYPE = {
  [INVESTMENT_FLOW_MAPPER.buildwealth]: BUILDWEALTH,
  [INVESTMENT_FLOW_MAPPER.savetax]: SAVETAX,
  [INVESTMENT_FLOW_MAPPER.investsurplus]: INVESTSURPLUS,
  [INVESTMENT_FLOW_MAPPER.saveforgoal]: SAVE_FOR_GOAL,
};

export default INVESTMENT_TYPE;
